/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslocoModule } from '@jsverse/transloco';

import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { TelemetryModule } from 'src/app/telemetry/telemetry.module';
import { AvatarModule } from 'src/app/avatar/avatar.module';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { PopoverModule } from 'primeng/popover';
import { BulbSharePanelTranslationProvider } from './translation-provider';

import { AsyncDropdownComponent } from './async-dropdown/async-dropdown.component';
import { PrivateShareLinkComponent } from './private-share-link/private-share-link.component';
import { CreateNewLinkDialogComponent } from
  './private-share-link/create-new-link-dialog/create-new-link-dialog.component';
import { ShareFormComponent } from './share-form/share-form.component';
import { ShareButtonComponent } from './share-button/share-button.component';
import { AeroModule } from '../../aero/aero.module';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { SharePanelComponent } from './share-panel/share-panel.component';
import { RunInViewDirective } from './run-in-view.directive';
import { HttpService } from './http.service';
import { WindowScrollingService } from './window-scrolling.service';
import { InviteFormComponent } from './invite-form/invite-form.component';
import { ModalSelectInputComponent } from './modal-select-input/modal-select-input.component';
import { SocialShareComponent } from './social-share/social-share.component';
import { UsersChecklistComponent } from './users-checklist/users-checklist.component';
import { UnitChipComponent } from './unit-chip/unit-chip.component';
import { GenericAlertComponent } from './generic-alert/generic-alert.component';
import { ShareToggleTextComponent } from './share-toggle-text/share-toggle-text.component';
import { IsLastByKeyPipe } from './is-last-by-key.pipe';
import { IsEmptyPipe } from './is-empty.pipe';
import { GenericDialogComponent } from './generic-dialog/generic-dialog.component';
import { ShareStateStore } from './share-state.store';

@NgModule({
  declarations: [
    AsyncDropdownComponent,
    PrivateShareLinkComponent,
    CreateNewLinkDialogComponent,
    ShareButtonComponent,
    SharePanelComponent,
    ShareFormComponent,
    RunInViewDirective,
    SocialShareComponent,
    InviteFormComponent,
    ModalSelectInputComponent,
    UsersChecklistComponent,
    UnitChipComponent,
    GenericAlertComponent,
    GenericDialogComponent,
    ShareToggleTextComponent,
    IsLastByKeyPipe,
    IsEmptyPipe,
  ],
  imports: [
    // Angular modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Bulb modules
    AeroModule,
    AvatarModule,
    TelemetryModule,

    // PrimeNG modules
    CheckboxModule,
    DynamicDialogModule,
    MultiSelectModule,
    PopoverModule,
    SelectButtonModule,
    ToastModule,
    TooltipModule,

    // Other modules
    SVGIconModule,
    TranslocoModule,
    SvgIconComponent,
  ],
  exports: [
    ShareButtonComponent,
  ],
  providers: [
    HttpService,
    WindowScrollingService,
    BulbSharePanelTranslationProvider,
    ShareStateStore,
    DialogService,
  ],
})
export class SharePanelModule { }
